import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { TTMSAppSource } from '../../../types/tracking'
import { TMSAppInfo } from './tms-app-info'
import { TMSAppTrackingInfo } from './tms-app-tracking-info'

interface TMSAppSourceProps {
  shipmentID: string
  trackingSourceData: TTMSAppSource
}

/**
 * TMSAppSource displays the TMS App location data for the shipment.
 */
export const TMSAppSource = (props: TMSAppSourceProps) => {
  const { trackingSourceData, shipmentID } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full">
        <div className="w-full">
          <TMSAppInfo trackingSourceData={trackingSourceData} shipmentID={shipmentID} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <TMSAppTrackingInfo trackingSourceData={trackingSourceData as TTMSAppSource} />
      </HoverCardContent>
    </HoverCard>
  )
}
